"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.settings = void 0;
exports.settings = (override = {}) => ({
    language: 'graphqle',
    glyphMargin: true,
    theme: 'graphql-editor',
    smoothScrolling: true,
});
